import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Link } from "react-router-dom";
import ToggleBtn from "../../components/partials/ToggleBtn";

const SortableRow = React.memo(
  ({
    item,
    index,
    page,
    limit,
    handleStatusChange,
    formatDate,
    openDelete,
  }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: item._id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      backgroundColor: isDragging ? "#f7f7f7" : "#fff",
      willChange: transform ? "transform" : "auto",
      zIndex: isDragging ? 1 : "auto",
    };

    return (
      <tr ref={setNodeRef} style={style}>
        <td
          style={
            item.status === "active" ? { borderLeft: "5px solid green" } : {}
          }
        >
          <i
            className="fas fa-arrows-alt text-dark fs-16 lh-1 handle me-2"
            style={{ cursor: "grab" }}
            {...attributes}
            {...listeners}
          ></i>
          <b>{(page - 1) * limit + index + 1}.</b>
        </td>

        <td>
          <div className="d-flex align-items-center">
            {item.image && (
              <a
                href={item.image || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="avatar avatar-lg me-2"
              >
                <img src={item.image} alt="img" />
              </a>
            )}
            <div>
              <h6 className="fw-bold mb-1">{item.customer_name}</h6>
              <p className="fs-12">{item.designation}</p>
            </div>
          </div>
        </td>

        <td>{item.company_name || ""}</td>
        <td>{formatDate(item.createdAt)}</td>

        <td className="action-table-data">
          <div className="edit-delete-action">
            <ToggleBtn
              active={item.status === "active"}
              onClick={() =>
                handleStatusChange(
                  item._id,
                  item.status === "active" ? "inactive" : "active",
                )
              }
              activeText="Deactivate"
              inActiveText="Activate"
            />

            <Link to={`/testimonials/edit/${item._id}`} className="me-2 p-2">
              <i className="ti ti-pencil" />
            </Link>

            <a
              className="p-2"
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              onClick={() => openDelete(item._id)}
            >
              <i className="ti ti-trash" />
            </a>
          </div>
        </td>
      </tr>
    );
  },
);

export default SortableRow;
